import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';
import {
  areAllPermissionsEnabled,
  getSocietyPermissionEntry,
} from 'modules/society/utils/societyPermissions';

import { Society, User } from 'types';

type AdministratorAccessBadgeProps = {
  administrator: User;
  society: Society;
};

const AdministratorAccessBadge: FC<AdministratorAccessBadgeProps> = ({
  administrator,
  society,
}) => {
  const { t } = useTranslate();

  const badge = {
    text: 'Full',
    color: 'danger',
  };

  const currentSocietyPermissions = getSocietyPermissionEntry(
    administrator?.adminPermissions,
    society?.['_id']
  );

  const hasAllPermissionsEnabled = areAllPermissionsEnabled(
    currentSocietyPermissions
  );

  if (currentSocietyPermissions && !hasAllPermissionsEnabled) {
    badge.text = t('Limited');
    badge.color = 'warning';
  }

  return (
    <span className={`badge badge-dot badge-${badge.color}`}>
      {t(badge.text)}
    </span>
  );
};

export default AdministratorAccessBadge;
